import { AnimateDiv } from '@/components/Common/AnimateDiv';
import { SvgLogo } from '@/components/Home/icon';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <section className="lg:py-[5.5rem] py-[38px] lg:pb-[4.3125rem] pb-[27px] text-center bg-[#000]">
      <div className="mx-auto">
        <AnimateDiv>
          <h2 className="text-2xl font-bold text-white">GBase Makes You Genius</h2>
        </AnimateDiv>
        <AnimateDiv>
          <p className="text-2xl mt-2 font-bold tracking-widest text-white">で き る を 授 け る</p>
        </AnimateDiv>

        <AnimateDiv className="flex justify-center items-center my-8">
          <SvgLogo />
        </AnimateDiv>

        <AnimateDiv>
          <p className="text-base md:text-xl">
            今すぐ GBase Support を始めて、AIが問い合わせ対応を自動化する世界を体験しよう
          </p>
        </AnimateDiv>
        <AnimateDiv>
          <div className="text-[#FFF] lg:font-inter font-black lg:text-[32px] text-[14px] text-center">
            03-3527-2828
          </div>
          <div className="font-poppins lg:text-[1.25rem] text-[8px] lg:mb-[2.375rem] mb-[17px] text-[#FFF]">
            受付時間: 平日 10:00〜18:00
          </div>
        </AnimateDiv>

        {/* <button
          className="bg-[#000] text-white rounded-full lg:text-[16px] text-[8px] font-semibold cursor-pointer transition-colors duration-300 lg:h-[3.75rem] h-[30px] lg:w-[10.375rem] w-[74px] hover:opacity-90 active:bg-[#5b60e2]"
          onClick={() => navigate('/contact')}
        >
          お問い合わせ→
        </button> */}
        <motion.div
          className="mt-10 flex items-center justify-center gap-x-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <a
            href={import.meta.env.VITE_ADMIN_URL}
            target="_blank"
            // onClick={() => {
            //   signup();
            // }}
            className="rounded-full bg-white px-6 py-3 text-sm font-semibold text-black shadow-sm border border-white hover:bg-black hover:text-white transition-all"
          >
            無料トライアル
          </a>
          <a
            target="_blank"
            className="rounded-full border border-white px-6 py-3 text-sm shadow-sm font-semibold text-white cursor-pointer hover:bg-white hover:text-black"
            onClick={() => {
              navigate('/contact');
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }}
          >
            問い合わせ <span aria-hidden="true">→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
